import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import managedTeams from 'utils/session/managedTeams';

/**
 * Check whether the currently logged-in user is a team manager.
 *
 * Returns true when the current user is a manager
 * of any team, or of the team whose ID was passed in
 *
 * teamId - Optional ID of a team
 */

export function isTeamManager(teamId) {
  var userManagedTeams = managedTeams();
  if (userManagedTeams.length === 0) {
    return false;
  }
  return teamId ? Boolean(userManagedTeams.find(function (team) {
    return +team.id === +teamId;
  })) : true;
}